export function shouldShowNone(value?: string | null): boolean {
  return !value || value === 'null' || typeof value !== 'string';
}
